import React, { useState } from "react";
import Home from "../Pages/Home";
import FolderView from "./FolderView";
import FloatingAIButton from "../../FloatingAIButton/FloatingAIButton";
import { useSelector, useDispatch } from "react-redux";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
} from "../../../state/reducers/chatDrawerReducers";

const Main = () => {
  const [currentFolder, setCurrentFolder] = useState({
    id: 0,
    name: "Repository",
  });

  const [path, setPath] = useState([{ id: 0, name: "Repository" }]);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const dispatch = useDispatch();

  const handleFolderClick = (newPath) => {
    if(Array.isArray(newPath)){
      let currFol = newPath?.[newPath.length -1]
      setCurrentFolder(currFol);
      setPath((prev) => [...prev, ...newPath]);
      return
    } 
    setPath((prev) => [...prev, newPath]);
    setCurrentFolder(newPath);
  };

  return (
    <div className="h-full">
      {currentFolder?.id === 0 ? (
        <Home folderClick={handleFolderClick} />
      ) : (
        <FolderView
          setPath={setPath}
          setCurrentFolder={setCurrentFolder}
          path={path}
          currentFolder={currentFolder}
          folderClick={handleFolderClick}
        />
      )}
      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </div>
  );
};

export default Main;
